export default "__VITE_ASSET__BVczaY5b__"